import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './users.css'
import AdminNavbar from '../../admin-components/admin-nav/AdminNavbar'
import AdminBottomNav from '../../admin-components/adminbottomnav/AdminBottomNav'
import User from '../../admin-components/user/User';

function Users() {
    const [users, setUsers] = useState([]);

    const api_uri = "https://mentorxfa.herokuapp.com/api/users";

    useEffect(() => {
        const fetchCats = async() => {
            const res = await axios.get(api_uri);
            setUsers(res.data);           
        }
        fetchCats() 
        return () => {          
          };
    }, []);
    return (
        <>
        <AdminNavbar/>
        <div className="users">
        <h3 className="users-title" >Users</h3>
        <div className="users-wrap">
           
        {
                users.map((user) =>(
                    <Link key={user._id} to={`/admin/users/${user._id}`}>
                        <User key={user._id} user={user} />
                    </Link>
                ))
        }   
        </div>
        </div>
        <AdminBottomNav/>
        </>
    )
}

export default Users
